<template>
    <ins class="hidden-string" v-cloak @click="reveal = !reveal" :class="{reveal:reveal}">
        {{result}}
    </ins>
</template>

<script>
    export default {
        props: {
            value: {
                required: true,
                type: String
            }
        },

        data: function(){
            return {
                reveal: false
            };
        },

        computed: {
            result: function(){
                if( this.reveal ){
                    return this.value;
                }
                else if( typeof this.value === 'string' ){
                    return _.repeat( '*', this.value.length );
                }

                return '-';

            }
        },
    }
</script>
